@for (notification of globalNotifications(); track $index) {
  <mwe-notification-banner
    [type]="notification.type"
    [emphasis]="notification.emphasis"
    [text]="notification.text"
    [iconClass]="notification.iconClass ?? null"
    [isClosable]="notification.isClosable ?? false"
    [closeButtonTitle]="notification.closeButtonTitle ?? ''"
    (closeClick)="onCloseClick(notification)"
  />
}
